'use client'
import RadioGroup from '@/src/components/common/RadioGroup'
import styles from '../../OnboardingForm.module.scss'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'
import Img from '@/src/components/common/Img/Img'
import CheckboxGroup from '@/src/components/common/CheckboxGroup'

export default function GettingStartedMoreDetailsForm() {
  const [onboardingData] = useState(readStoredData())

  return (
    <>
      <div>
        <h3 className={styles.heading}>
          Have you registered with My Aged Care to begin the process?
        </h3>
        {(() => {
          const name = 'more_details__getting_started__has_registered'
          return (
            <RadioGroup
              required
              options={[
                {
                  value: 'yes',
                  display: `Yes, I’ve registered`,
                },
                {
                  value: 'no',
                  display: `No, not yet`,
                },
                {
                  value: 'not_sure',
                  display: `I’m not sure where to start`,
                },
              ]}
              name={name}
              value={(onboardingData.data?.[name] || '') as string}
              className={styles.plainOptions}
            />
          )
        })()}
        <hr />
        <div>
          <h3 className={styles.heading}>{`Let’s look in some resources`}</h3>
          {`Are there any specific areas you would like to understand more about? You can select more than one option`}
        </div>
        <div className={styles.plainOptions}>
          {(() => {
            const name = 'more_details__getting_started__inquiries'
            return (
              <CheckboxGroup
                required={1}
                name={name}
                values={(onboardingData.data?.[name] || []) as string[]}
                options={[
                  'How to apply for a Support at Home funding',
                  'What happens during the assessment',
                  'Understanding package levels and funding',
                  'How to choose a provider',
                  'How fees and costs work',
                  'I’m not sure',
                ]}
              />
            )
          })()}
        </div>
      </div>
      <div>
        <Img src={bgimage.src} className={styles.desktop} />
        <Img src={bgimageMobile.src} className={styles.mobile} />
      </div>
    </>
  )
}
